<!-- 产品-产品列表 -->
<template>
  <div class="md-layout">
    <!-- 设备列表 + 查询表单 -->
    <!-- 卡片一-筛选查询用表单 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <div class="md-layout card-form" :style="{'align-items':'center','border-bottom':'1px solid #ddd','padding-bottom':'16px','max-width':'400px'}">
            <!-- 返回设备列表 -->
            <div class="md-layout-item md-size-50 md-small-size-40">
              <md-field>
                <md-select v-model="searchForm.id">
                  <md-option v-for="item in tableData" :key="item.id" :value="item.id">{{item.main.name}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-40">
              <md-field>
                <md-select v-model="searchForm.lang">
                  <md-option :value="'en'">{{$I18n('en')}}</md-option>
                  <md-option :value="'zh-CN'">{{$I18n('zh-CN')}}</md-option>
                  <md-option :value="'zh-TW'">{{$I18n('zh-TW')}}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <add-button @click="addProduct">{{$I18n("add_setting")}}</add-button>
          <md-button @click="editPush" :style="{'float': 'right', 'margin-top': '14px'}" class="md-info">{{$I18n('email_alarm')}}</md-button>
          <!-- 卡片-主体-选择表格栏  -->
          <div :style="{'display':'flex'}">
            <tabs @changeActive="changeLeftTabs" :tab-name="[$I18n('basic_info'), $I18n('know_base')]" class="tabs-content" flex-column color-button="info">
              <template slot="tab-pane-1"><div /></template>
              <template slot="tab-pane-2"><div /></template>
            </tabs>
            <!-- 卡片-主体-表格-当前版本选择 -->
            <div v-if="active === $I18n('basic_info')" class="tabs-contant">
              <!-- 卡片-主体-按钮-添加新的版本 -->
              <div class="md-layout card-form">
                <div class="md-layout md-layout-item md-size-100" :style="{'border-bottom':'1px solid #bbb', 'align-items':'center'}">
                  <h4>{{$I18n('basic_info')}}</h4>
                  <div class="md-layout-item right-layout-item" :style="{'text-align':'right','padding-right':'0'}">
                    <md-button @click="editBot" class="md-info">
                      {{$I18n("save")}}
                    </md-button>
                  </div>
                </div>
              </div>
              <div class="md-layout card-form">
                <div class="md-layout card-form md-layout-item md-size-60 md-xsmall-size-100">
                  <!-- 表单-输入栏-企业签名 -->
                  <div class="md-layout-item md-size-100">
                    <div class="md-layout">
                      <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left'}">
                        {{$I18n("name") /*$I18n("force_update_select")*/}}:
                      </label>
                      <div class="md-layout-item md-size-100 md-form-item">
                        <md-field>
                          <md-input v-model="infoForm.name"/>
                        </md-field>
                      </div>
                    </div>
                  </div>
                  <!-- 表单-输入栏-企业签名 -->
                  <div class="md-layout-item md-size-100">
                    <div class="md-layout">
                      <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left'}">
                        {{"企业个签" /*$I18n("force_update_select")*/}}:
                      </label>
                      <div class="md-layout-item md-size-100 md-form-item">
                        <md-field>
                          <md-input v-model="infoForm.work_time"/>
                        </md-field>
                      </div>
                    </div>
                  </div>
                  <!-- 表单-输入栏-欢迎语 -->
                  <div class="md-layout-item md-size-100">
                    <div class="md-layout">
                      <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left'}">
                        {{"欢迎语" /*$I18n("force_update_select")*/}}:
                      </label>
                      <div class="md-layout-item md-size-100 md-form-item">
                        <md-field>
                          <md-input v-model="infoForm.welcomes"/>
                        </md-field>
                      </div>
                    </div>
                  </div>
                  <!-- 表单-输入栏-欢迎语 -->
                  <div class="md-layout-item md-size-100">
                    <div class="md-layout">
                      <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left'}">
                        {{"人工客服欢迎" /*$I18n("force_update_select")*/}}:
                      </label>
                      <div class="md-layout-item md-size-100 md-form-item">
                        <md-field>
                          <md-input v-model="infoForm.staff_msg"/>
                        </md-field>
                      </div>
                    </div>
                  </div>
                  <!-- 表单-输入栏-欢迎语 -->
                  <div class="md-layout-item md-size-100">
                    <div class="md-layout">
                      <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left'}">
                        {{"主语言" /*$I18n("force_update_select")*/}}:
                      </label>
                      <div class="md-layout-item md-size-100 md-form-item">
                        <md-field>
                          <md-select v-model="infoForm.main_lang">
                            <md-option v-if="infoForm.details && infoForm.details.filter(i => i.lang==='en').length > 0" :value="'en'">{{$I18n('en')}}</md-option>
                            <md-option v-if="infoForm.details && infoForm.details.filter(i => i.lang==='zh-CN').length > 0" :value="'zh-CN'">{{$I18n('zh-CN')}}</md-option>
                            <md-option v-if="infoForm.details && infoForm.details.filter(i => i.lang==='zh-TW').length > 0" :value="'zh-TW'">{{$I18n('zh-TW')}}</md-option>
                          </md-select>
                        </md-field>
                      </div>
                    </div>
                  </div>
                  <!-- 表单-选择框-状态 {1: 开启, 2: 关闭} -->
                  <div class="md-layout-item md-size-100">
                    <div class="md-layout">
                      <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left'}">
                        {{$I18n("state")}}:
                      </label>
                      <div class="md-layout-item md-size-100 md-form-item">
                        <md-field>
                          <md-select v-model="infoForm.state">
                            <md-option :value="1">{{$I18n('open')}}</md-option>
                            <md-option :value="2">{{$I18n('close')}}</md-option>
                          </md-select>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <!-- 表单-机器人KEY -->
                  <div class="md-layout-item">
                    <div class="md-layout">
                      <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left'}">
                        {{"机器人KEY" /*$I18n("force_update_select")*/}}:
                      </label>
                      <div class="md-layout-item md-size-100 md-form-item">
                        <md-field>
                          <md-input disabled v-model="infoForm.key"/>
                        </md-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="active === $I18n('know_base')" class="tabs-contant md-layout">
              <div class="md-layout-item md-size-100" :style="{'border-bottom':'1px solid #bbb'}">
                
                <h4>{{$I18n('know_base')}}</h4>
              </div>
              <div class="md-layout-item md-size-30">
                <!-- 表格 { 点击后可展示对应的子菜单 }
                  ID
                  名称 {中文下显示中文, 其他时候显示英文}
                  菜单KEY
                  操作 [修改主菜单, 删除主菜单]
                 -->
                 <div :style="{'display':'flex','align-items':'center','margin-top':'8px'}">
                  <h4>分类</h4>
                  <div class="md-layout-item right-layout-item" :style="{'text-align':'right'}">
                    <md-button @click="addBotWiki" class="md-just-icon md-round md-info">
                      <md-icon>add</md-icon>
                    </md-button>
                  </div>
                </div>
                <md-table>
                  <md-table-row @click="() => {table_selectMainMenu(item)}" v-for="item in wikiData" :key="item.id">
                    <md-table-cell :style="{'font-weight': (!selectWiki || selectWiki !== item.id)?'200' :'600'}">{{ item.name }}</md-table-cell>
                    <md-table-cell class="button-box">
                      <md-button @click="editBotWiki(item)" @click.stop class="md-just-icon md-round md-info left-icon">
                        <md-icon>edit</md-icon>
                      </md-button>
                      <md-button @click="delBotWiki(item)" @click.stop class="md-just-icon md-round md-danger md-info">
                        <md-icon>close</md-icon>
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                  <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
                </md-table>
              </div>
              <div class="md-layout-item md-size-70">
                <!-- 表格 { 点击后可展示对应的子菜单 }
                  ID
                  名称 {中文下显示中文, 其他时候显示英文}
                  菜单KEY
                  操作 [修改子菜单, 删除子菜单]
                 -->
                 <div :style="{'display':'flex','align-items':'center','margin-top':'8px'}">
                  <h4>自定义问答</h4>
                  <div class="md-layout-item right-layout-item" :style="{'text-align':'right'}">
                    <md-button @click="addBotWikiDetail" class="md-info md-just-icon md-round">
                      <md-icon>add</md-icon>
                    </md-button>
                  </div>
                </div>
                <md-table>
                  <md-table-row v-for="item in wikiDetailData" :key="item.id">
                    <md-table-cell>{{ item.title.length>10 ?item.title.slice(0,10) :item.title }}</md-table-cell>
                    <md-table-cell>{{ item.content.length>30 ?item.content.slice(0,30) :item.content }}</md-table-cell>
                    <md-table-cell  class="button-box">
                      <md-button @click="editBotWikiDetail(item)" @click.stop class="md-just-icon md-round md-info left-icon">
                        <md-icon>edit</md-icon>
                      </md-button>
                      <md-button @click="delBotWikiDetail(item)" @click.stop class="md-just-icon md-round md-danger md-info">
                        <md-icon>close</md-icon>
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <modal v-show="openModal" @close="modal_classicModalHide" :type="openModalType==='del-wiki' || openModalType==='del-wiki-detail' ?'' :'rightModal'">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{modalTitle}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='del-wiki'">
          {{$I18n("check_delete", wikiModalData.Form.name)}}
        </div>
        <div v-else-if="openModalType==='del-wiki-detail'">
          {{$I18n("check_delete", wikiDetailModalData.Form.title)}}
        </div>
        <div v-else-if="openModalType==='add-wiki'|| openModalType === 'edit-wiki'">
          <!-- 表单-输入栏-名字 -->
          <modal-form-item :label='$I18n("name") ' :required="true">
            <md-field :class="{'md-error' : wikiModalData.Error.name}">
              <md-input v-model="wikiModalData.Form.name"/>
              <md-icon v-if="wikiModalData.Error.name">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 表单-输入栏-名字 -->
          <modal-form-item :label='$I18n("sort_num") ' :required="true">
            <md-field :class="{'md-error' : wikiModalData.Error.sort}">
              <md-input v-model="wikiModalData.Form.sort"/>
              <md-icon v-if="wikiModalData.Error.sort">clear</md-icon>
            </md-field>
          </modal-form-item>
        </div>
        <div v-else-if="openModalType==='add-wiki-detail'|| openModalType === 'edit-wiki-detail'">
          <!-- 表单-输入栏-名字 -->
          <modal-form-item :label='$I18n("question") ' :required="true">
            <md-field :class="{'md-error' : wikiDetailModalData.Error.title}">
              <md-input v-model="wikiDetailModalData.Form.title"/>
              <md-icon v-if="wikiDetailModalData.Error.title">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 表单-输入栏-名字 -->
          <modal-form-item :label='$I18n("answer") ' :required="true">
            <md-field :class="{'md-error' : wikiDetailModalData.Error.content}">
              <md-textarea :style="{'padding':'0'}" v-model="wikiDetailModalData.Form.content"/>
              <md-icon v-if="wikiDetailModalData.Error.content">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 表单-输入栏-名字 -->
          <modal-form-item :label='$I18n("sort_num") ' :required="true">
            <md-field :class="{'md-error' : wikiDetailModalData.Error.sort}">
              <md-input v-model="wikiDetailModalData.Form.sort"/>
              <md-icon v-if="wikiDetailModalData.Error.sort">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 表单-输入栏-名字 -->
          <modal-form-item :label='$I18n("state") ' :required="true">
            <md-field>
              <md-select v-model="wikiDetailModalData.Form.state">
                <md-option :value="1">{{$I18n('open')}}</md-option>
                <md-option :value="2">{{$I18n('close')}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>
        </div>
        <!-- 弹窗-修改/添加设备 -->
        <div v-else>
          <!-- 表单-输入栏-名字 -->
          <modal-form-item :label='$I18n("name") ' :required="true">
            <md-field :class="{'md-error' : modalData.Error.name}">
              <md-input v-model="modalData.Form.name"/>
              <md-icon v-if="error.name">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 表单-选择栏-所属公司 -->
          <modal-form-item v-if="UserInfo.role_id < 10000" :label='$I18n("company")'>
            <md-field>
              <md-select v-model="modalData.Form.comp_id">
                <md-option v-for="item in compData" :value="item.comp_id" :key="item.comp_id">{{item.comp_name}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>
          <!-- 表单-选择栏-产品类型 -->
          <modal-form-item :label='$I18n("lang")'>
            <md-field>
              <md-select :disabled="openModalType == 'edit'" v-model="modalData.Form.lang">
                <md-option :value="'en'">{{$I18n('en')}}</md-option>
                <md-option :value="'zh-CN'">{{$I18n('zh-CN')}}</md-option>
                <md-option :value="'zh-TW'">{{$I18n('zh-TW')}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>

          <!-- <modal-form-item :label='$I18n("product_type")'> -->
          <modal-form-item :label='"欢迎词"'>
            <md-field>
              <md-input v-model="modalData.Form.welcomes" />
            </md-field>
          </modal-form-item>

          <!-- <modal-form-item :label='$I18n("product_type")'> -->
          <modal-form-item :label='"工作时间"'>
            <md-field>
              <md-input v-model="modalData.Form.work_time" />
            </md-field>
          </modal-form-item>

          <modal-form-item :label='$I18n("state")'>
            <md-field>
              <md-select v-model="modalData.Form.state">
                <md-option :value="1">{{$I18n('open')}}</md-option>
                <md-option :value="2">{{$I18n('close')}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>
        </div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button class="md-info" @click="modal_submit">{{$I18n("sure")}}</md-button>
        <md-button class="left-icon" @click="modal_classicModalHide">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>

    <simple-modal ref="push"
      :title = "$I18n('email_alarm')"
      :right = "true"
      @submit= "modal_push_submit"
    >
      <template slot="body">
        <common-form-item 
          v-for="item in form_modalPushData" 
          v-model="modalPushData.Form[item.keys]" 
          :error="modalPushData.Error[item.keys]" 
          :key="item.keys" v-bind="item"
        />
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
import { Tabs } from "@/components";
// import { timestampToString } from "@/common/tools.js";
import { timestampToString1000, FormClass } from "@/common/tools.js";

export default {
  components: {
    Tabs,
    Modal,
  },
  data() {
    return {
      emptyArray : [],
      selectWiki: 0,
      wikiData      : [],
      wikiDetailData: [],
      infoForm :{
        name      : "",
        comp_sign : "",
        welcome   : "",
        state     : 1,
        key : "",
        staff_msg:"",
      },
      searchData : {   // 表格-查询范围
        name : "",
        pk : "",
        comp_id: "",
      },
      productType: [], // 设备类型 (通过请求获取)
      searchForm : {   // API-查询范围
        id : 0,
        lang : 'en',
      },
      active : this.$I18n('basic_info'), // 展示的内容 {fir_update: 固件版本, setting_product: 商品配置}
      useing_version : "",    // 表单-当前使用版本
      ver_tableInitData : [], // 表格-版本数据 (原始数据)
      ver_count  :0,          // 表格-版本数据总数
      ver_pageNo :0,          // 表格-版本数据当前页码
      selected : {},          // 表格-当前选择的设备

      imageRegular : "",      // 选择图片
      regularImg : "/img/image_placeholder.jpg", // 当前展示的图片

      // 表格相关
      icon  : "dns", // 表格-ICON
      title : this.$I18n("cust_ser_conf"), // 表格-卡片标题
      tableInitData : [],                 // 表格-原始数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,   // 表格-每页数据数量
      currentPage : 1, // 表格-现在所处页数
      total : 0,       // 表格-数据总数
      // 弹窗相关
      openModal: false,   // 弹窗-是否打开
      modalTitle : "",    // 弹窗-标题
      openModalType : "", // 弹窗-弹窗类型
      modalPushData: new FormClass({
        state :0,
        time  : () => {return []},
      }),
      modalData :new FormClass({        // 弹窗-表单参数
        name       : {
          init     : "",
          check    : "required",
        },
        comp_id    : this.UserInfo.comp_id,
        lang       : "en",
        welcomes   : "",
        work_time  : "",
        state      : 1,
      }),
      wikiModalData  :new FormClass({
        id: 0,
        name : {
          init     : "",
          check    : "required",
        },
        sort : {
          init     : 0,
          check    : "int",
        },
      }),
      wikiDetailModalData  :new FormClass({
        id         : 0,
        title: {
          init     : "",
          check    : "required",
        },
        content: {
          init     : "",
          check    : "required",
        },
        sort : {
          init     : 0,
          check    : "int",
        },
        state      : 1,
      }),
      modalDataAttr : {
        lifecycle: 1,
      },
      error : {           // 弹窗-表单数据校验结果
        name : false,
      }
    };
  },
  mounted : function() {
    if(!this.UserInfo.comp_id){
      this.$api.userInfo({type: 1})
        .then(this.$Then(res => {
          this.searchForm.comp_id = res.data.comp_id;
          this.searchData.comp_id = res.data.comp_id;
          this.api_getPageData().then(() => {
            if(this.tableData.length === 0){
              return 
            }
            this.searchForm.id = this.tableData[0].id
          });
          this.api_getComp();
          this.api_getProductType();
        }))
        .catch(this.$Catch())
    } else {
      this.searchForm.comp_id = this.UserInfo.comp_id;
      this.searchData.comp_id = this.UserInfo.comp_id;
      this.api_getPageData().then(() => {
        if(this.tableData.length === 0){
          return 
        }
        this.searchForm.id = this.tableData[0].id
      });
      this.api_getComp();
      this.api_getProductType();
    }
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
    selectWiki(newValue){
      if(newValue == 0 ){
        this.wikiDetailData = []
      } else  {
        this.api_getWikiDetail()
      }
    },
    "searchForm.id":{
      handler(newValue, oldValue){
        let botData = this.tableData.filter(item => item.id === parseInt(newValue))
        if(this.searchForm.lang !== botData[0].main.lang && newValue !== oldValue){
          this.searchForm.lang = botData[0].main.lang
          return 
        }
      }
    },
    searchForm:{
      handler(newValue){
        let botData = this.tableData.filter(item => item.id === parseInt(newValue.id))
        if(botData.length > 0){
          let detailData = botData[0].details.filter(item => item.lang === newValue.lang)
          if(detailData.length > 0){
            this.infoForm = {
              ...detailData[0],
              ...botData[0],
              main_lang:  botData[0].main.lang,
              detail_id : detailData[0].id,
              name : detailData[0].name,
            }
            this.api_getWiki();
            return;
          }
          this.infoForm = {
            comp_sign : "",
            welcome   : "",
            staff_msg:"",
            main_lang:  botData[0].main.lang,
            ...botData[0],
          }
          this.wikiData = [];
          this.wikiDetailData = [];
          return
        }
        this.infoForm ={
          staff_msg:"",
          comp_sign : "",
          welcome   : "",
          state     : 1,
          key : "",
        }
        this.wikiData = [];
        this.wikiDetailData = [];
      },
      immediate: true,
      deep: true,
    }
  },
  computed: {
    tableData(){
      return [...this.tableInitData]
        // .splice((this.ver_pageNo-1) * this.pageSize, this.pageSize)
        .map(item => {
          // 版本状态
          let state_name = "";
          switch (item.state) {
            case 1:
              state_name = this.$I18n("open") 
              break;
            case 2:
              state_name = this.$I18n("close")
              break;
            default:
              state_name = this.$I18n("unknow_state")
              break;
          }
          return {
            ...item,
            state_name,
            main: item.details.filter(sub => {return sub.lang === item.lang})[0],
            create_time: timestampToString1000(item.gmt_create),
          }
        })
    },
    ver_tableData(){ // 表格-表格数据
      return [...this.ver_tableInitData]
        .splice((this.ver_pageNo-1) * this.pageSize, this.pageSize)
        .map(item => {
          // 版本更新方式
          let type_name = "";
          switch (item.type) {
            case 1:
              type_name = this.$I18n("force") 
              break;
            case 2:
              type_name = this.$I18n("user_select")
              break;
            default:
              type_name = this.$I18n("unknow_state")
              break;
          }
          // 版本等级
          let level_name = "";
          switch (item.level) {
            case 1:
              level_name = this.$I18n("low") 
              break;
            case 2:
              level_name = this.$I18n("center")
              break;
            default:
              level_name = this.$I18n("high")
              break;
          }
          // 版本状态
          let state_name = "";
          switch (item.state) {
            case 1:
              state_name = this.$I18n("open") 
              break;
            case 2:
              state_name = this.$I18n("close")
              break;
            default:
              state_name = this.$I18n("unknow_state")
              break;
          }
          // 版本关联类型
          let link_type_name = "";
          switch (item.link_type) {
            case 0:
              link_type_name = this.$I18n("none")
              break;
            case 1:
              link_type_name = "UID"
              break;
            case 2:
              link_type_name = "MAC"
              break;
            default:
              link_type_name = ""//this.$I18n("unknow_state")
              break;
          }
          return {
            ...item,
            level_name,
            type_name,
            state_name,
            link_type_name,
            create_thing_time: timestampToString1000(item.gmt_create),
          }
        })
    },
    form_modalPushData(){
      return [
        {
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "radio",
          options : [
            {id:1, name: this.$I18n("open")},
            {id:2, name: this.$I18n("closed")},
          ],
        },{
          label   : this.$I18n("time_period"),
          keys    : "time",
          type    : "chips",
          placeholder: this.$I18n("input_in_this") + " " + this.$I18n('time_range_format'),
        },
      ]
    },
  },
  methods: {
    modal_push_submit(){
      const time = this.modalPushData.Form.time.map(this.stringhourToJsonint);
      if(time.some(i => i === "ERROR")){
        this.$errorMsg(this.$I18n("time_is_wrong"));
        return
      }
      this.$api.setFeedbackPush({
        state: this.modalPushData.Form.state,
        time : JSON.stringify(time),
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.push.close();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    editPush(){
      this.$api.getFeedbackPush({})
        .then(this.$Then(res => {
          this.$refs.push.open();
          this.modalPushData.Update({
            state : res.data.state ?res.data.state :2,
            time  : res.data.time  ?JSON.parse(res.data.time).map(this.jsonintToStringhour) :[],
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // {s:00, e:3600} => "00:00-01:00"
    jsonintToStringhour(js){
      return this.intToHour(js.s)+"-"+this.intToHour(js.e);
    },
    // "00:00-01:00" => {s:00, e:3600}
    stringhourToJsonint(str){
      try{
        const startEnd = str.split("-");
        const start = this.hourToInt(startEnd[0]);
        const end = this.hourToInt(startEnd[1]);
        if(start === -1 || end === -1){
          return "ERROR"
        }
        return {
          s: start,
          e: end,
        }
      } catch  {
        return "ERROR"
      }
    },
    // 00:00 => 0  01:00 => 3600
    hourToInt(h){
      const hArray = h.split(":")
      const res = parseInt(hArray[0]) * 3600 + parseInt(hArray[1]) * 60
      if(isNaN(res)){
        return -1
      } else {
        return res
      }
    },
    // 3600 => 01:00  0 => 00:00
    intToHour(i){
      let h = String(parseInt(i / 3600))
      let m = String(parseInt((i - h * 3600) / 60))
      if(h.length === 1){
        h = "0"+h
      }
      if(m.length === 1){
        m = "0"+m
      }
      return h+":"+m
    },
    addBotWiki(){
      this.wikiModalData.Reset();
      this.openModal = true;
      this.openModalType = "add-wiki"
      this.modalTitle = this.$I18n("add");
    },
    editBotWiki(item){
      this.wikiModalData.Update(item);
      this.openModal = true;
      this.openModalType = "edit-wiki"
      this.modalTitle = this.$I18n("edit");
    },
    delBotWiki(item){
      this.wikiModalData.Update(item);
      this.openModal = true;
      this.openModalType = "del-wiki"
      this.modalTitle = this.$I18n("delete");
    },
    addBotWikiDetail(){
      this.wikiDetailModalData.Reset();
      this.openModal = true;
      this.openModalType = "add-wiki-detail"
      this.modalTitle = this.$I18n("add");
    },
    editBotWikiDetail(item){
      this.wikiDetailModalData.Update(item);
      this.openModal = true;
      this.openModalType = "edit-wiki-detail"
      this.modalTitle = this.$I18n("edit");
    },
    delBotWikiDetail(item){
      this.wikiDetailModalData.Update(item);
      this.openModal = true;
      this.openModalType = "del-wiki-detail"
      this.modalTitle = this.$I18n("delete");
    },

    table_selectMainMenu(item){
      if(item){
        this.selectWiki = item.id; 
      }
    },
    api_getWiki(){
      this.$api.getFeedbackBotCate({
        detail_id : this.infoForm.detail_id,
      })
      .then(this.$Then(res => {
        this.wikiData = res.data
        if(this.wikiData.length > 0){
          this.selectWiki = this.wikiData[0].id
        } else {
          this.selectWiki = 0
        }
      }))
      .catch(this.$Catch(this.$I18n("get_error"), () => {
        this.wikiData = [];
        this.selectWiki = 0;
      }))
    },
    api_getWikiDetail(){
      this.$api.getFeedbackBotWiki({
        category_id : this.selectWiki,
      })
      .then(this.$Then(res => {
        this.wikiDetailData = res.data
      }))
      .catch(this.$Catch(this.$I18n("get_error"), () => {
        this.wikiDetailData = [];
      }))
    },
    form_changeSearchData () { // 表单-确认查询数据并重新查询
      this.searchData = {
        name : this.searchForm.searchType === 1 ?this.searchForm.searchValue :"",
        pk   : this.searchForm.searchType === 2 ?this.searchForm.searchValue :"",
        comp_id: this.searchForm.comp_id,
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
    changeLeftTabs(active){ // 详细界面-切换左侧菜单时的保险措施
      this.active = ""
      setTimeout(()=>{
        this.active = active;
      },100)
    },
    selecedItem(item){ // 表格-选择数据
      if(this.selected == item){
        this.selected = {};
      } else {
        this.selected = item;
      }
    },
    table_editVersion (item) { // 表格-修改版本
      this.openModal = true;
      this.modalTitle = this.$I18n("edit");
      this.openModalType = "sub-edit";
      this.modalData = {
        ...item,
        link_type : item.link_type ?item.link_type :0,
        details : item.details ?[...item.details.map(detail => {
          let inp_lang = "";
          if(!["en","zh-CN","zh-TW"].includes(detail.lang)){
            inp_lang = detail.lang;
          }
          return {
            ...detail,
            lang : inp_lang ?"other" :detail.lang,
            showContent: false,
            inp_lang,
          }
        })] :[],
      }
    },
    table_delVersion(item) { // 表格-删除版本
      this.openModal = true;
      this.modalTitle = this.$I18n("edit");
      this.openModalType = "sub-delete";
      this.modalData = {
        ...item,
      }
    },
    modal_addNewVersionDetail () { // 弹窗-表单-按钮-添加新的版本详情
      this.modalData.details.push({
        lang : "en",
        title: "",
        url:"",
        content:"",
        showContent:false,
        inp_lang: "",
      })
    },
    api_getProductVer(){ // API-获取产品版本列表
      this.$api.getProductVer({ // api: /ota/product/ver/get
        pk : this.selected.pk,
      })
        .then(this.$Then(res => {
          let useVer = res.data.filter(item => {
            return item.state === 1;
          })[0]
          if(useVer){
            this.useing_version = useVer.id;
          } else {
            this.useing_version = ""
          }
          this.ver_tableInitData = res.data;
          this.ver_count = res.data.length;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.useing_version = ""
          this.ver_tableInitData = [];
          this.ver_count = 0;
        }))
    },
    ...({
      onFileChange(e) { // 图片插件相关 {上传图片}
        let files = e.target.files || e.dataTransfer.files;
        if (!files  || !files.length) return;
        let reader = new FileReader();
        let vm = this;
        reader.onload = (e) => {
          vm.imageRegular = e.target.result;
        };

        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData) // api: /open/file/upload
          .then(this.$Then(res => {
            this.modalData.img = res.data;
            reader.readAsDataURL(files[0]);
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      },
      clickInput(){ // 图片插件-点击按钮 触发 img input
        this.$refs.file_input.click();
      },
    }),
    api_getProductType(){ // API-获取所有的商品类型
      this.$api.getProductType({ // api: /user/product/category/get
        parent_id: 0,
      })
        .then(this.$Then(res => {
          this.productType = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.productType = [];
        }))
    },
    api_getComp (){ // API-获取所有的公司
      //获取菜单
      this.$api.getCompanyList({}) // api: /user/company/query
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.compData = [];
        }))
    },
    api_getPageData(){ // API-获取页面数据
      // 云存储订单信息
      let page_no = this.currentPage;
      return this.$api.getFeedbackBot({ // api: /user/feedback/bot/get
        ...this.searchData,
        page_size: this.pageSize,
        page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          // 防止翻页太快导致的失误 不知道有没有用
          if (page_no !== this.currentPage) {
            return;
          }
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    addProduct (){ // 表格-打开 添加新的商品 弹窗
      this.modalData.Reset()
      this.openModal = true;
      this.openModalType = "add"
      this.modalTitle = this.$I18n("add");
    },
    editBot(){
        this.$api.setFeedbackBot({
          ...this.infoForm,
          lang: this.searchForm.lang,
          id: this.searchForm.id,
        }) // api: /user/product/add
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getPageData();
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))

      return  false
    },
    modal_classicModalHide () { // 弹窗-关闭弹窗
      if(this.selected.pk){
        this.api_getProductVer();
      } else {
        this.api_getPageData();
      }
      this.openModal = false;
      this.error = {
        name : false,
        level: false,
      }
    },
    modal_submit () { // 弹窗-提交表单
      if(this.openModalType == 'add'){
        if(this.modalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return
        }
        this.$api.addFeedbackBot(this.modalData.Form) // api: /user/product/add
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getPageData();
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("add_fail")))
      } else if (this.openModalType == "add-wiki") {
        if(this.wikiModalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return
        }
        this.$api.addFeedbackBotCate({
          ...this.wikiModalData.Form,
          detail_id: this.infoForm.detail_id,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getWiki()
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType == "edit-wiki") {
        if(this.wikiModalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return
        }
        this.$api.setFeedbackBotCate(this.wikiModalData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getWiki()
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType == "del-wiki") {
        this.$api.delFeedbackBotCate(this.wikiModalData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getWiki()
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
      } else if (this.openModalType == "add-wiki-detail") {
        if(this.wikiDetailModalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return
        }
        this.$api.addFeedbackBotWiki({
          ...this.wikiDetailModalData.Form,
          category_id: this.selectWiki,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getWikiDetail();
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType == "edit-wiki-detail") {
        if(this.wikiDetailModalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return
        }
        this.$api.setFeedbackBotWiki({
          ...this.wikiDetailModalData.Form,
          category_id: this.selectWiki,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getWikiDetail();
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType == "del-wiki-detail") {
        this.$api.delFeedbackBotWiki(this.wikiDetailModalData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getWikiDetail();
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  
  .md-form-label{
    padding-left: 15px !important;
    padding-rigth: 15px !important;
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px;
    text-align: left;
  }
  .tabs-content{
    width : 200px;
    box-shadow : none;
    border-right : 1px solid #ddd;
    border-radius: 0;
    margin-right : 18px;
  }
  .product-card-img{
    display: flex;
    align-items: center;
    padding-left: 0;
  }
  .product-card-img img{
    flex-shrink : 0;
  }
  .product-card-p {
    background-color: #eeeeee;
    display: inline;
    padding: 6px 12px;
    border-radius : 4px;
    font-weight: 400;
  }
  .tabs-contant{
    padding-top : 40;
    width: calc(100% - 240px);
    box-shadow: none;
  }
  .left-table {
    text-align: left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    margin-right : 16px;
  }
  .card-form {
    margin-top: 0;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>
